import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="w-full max-w-7xl mx-auto px-4 md:px-6 -mt-8 relative z-20" aria-label="漫画分类导航">
      <div className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70">
        <div className="flex items-center gap-3 flex-wrap justify-center">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex items-center gap-1.5 px-4 py-2 bg-background-100 hover:bg-primary-50 hover:text-primary-600 text-foreground-600 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer border border-transparent hover:border-primary-200"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className={`${cat.icon} text-sm`}></i>
              </span>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}